import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classes from './style.module.scss';
import Button from '../Form/Buttons/Button';
import Loader from '../Loader/Loader';
import ModalAttachedFile from './ModalAttachedFile/ModalAttachedFile';
import Checkbox from '../Form/Checkbox/Checkbox';
import accountHelpers from '../../../utils/accountHelpers';

const AttachedFile = ({
  header, attachments, firstLoad, requestStatus, isOpenModal, setIsOpenModal, onFileClick, hideActionButtons,
  onSaveFile, onCloseModal, onChangeFile, sendFile, typeOptions, setSendFile, type = 'patient',
  onCheckBoxChange = () => {}, isCheckedAllAttachedIds, scriptAttachedIds = [], historyTabRef = {}, btnLoad,
}) => {
  const isManufacturerUsers = accountHelpers.isInOneOfRoles(['Manufacturer Users']);

  return (
    <div className={`${classes.wrapper_doc} ${classes[type]}`}>
      <div>
        {!isManufacturerUsers && !hideActionButtons && (
          <Button
            title="Add new file"
            type="button"
            reverseColor
            addButton
            onClick={() => setIsOpenModal(true)}
          />
        )}

        {!!scriptAttachedIds.length && !hideActionButtons && (
          <div className={classes.copy_button}>
            <Button
              reverseColor
              title="Copy"
              onClick={() => historyTabRef.click()}
              buttonColor="#5F6C8E"
            />
          </div>
        )}
      </div>

      <ModalAttachedFile
        onSaveFile={onSaveFile}
        sendFile={sendFile}
        onCloseModal={onCloseModal}
        onChangeFile={onChangeFile}
        open={isOpenModal}
        typeOptions={typeOptions}
        setSendFile={setSendFile}
        btnLoad={btnLoad}
        type={type}
      />

      {requestStatus === 'request' && firstLoad && (
        <Loader className={classes.doc_loader} />
      )}

      {requestStatus === 'success' && (
        <>
          {!attachments.length
            ? <div className={classes.notResult}>No Data Found</div>

            : (
              <div className={`${classes.table_wrapper} ${isManufacturerUsers ? classes.manufacturer : ''}`}>
                <div>
                  <table>
                    <thead>
                      <tr>
                        {type === 'script' && !isManufacturerUsers && !hideActionButtons && (
                        <th className={classes.th_checkbox}>
                          <Checkbox
                            onChange={() => onCheckBoxChange('all')}
                            checked={isCheckedAllAttachedIds}
                          />
                        </th>
                        )}

                        {header.map((h) => (
                          <th key={h.name}>{h.name}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {attachments.map((d) => (
                        type === 'script'

                          ? (
                            <tr
                              key={`${d.attachmentId}`}
                              className={`${classes.tr} ${scriptAttachedIds.includes(d.attachmentId)
                                ? classes.active : ''}`}
                            >
                              {!isManufacturerUsers && !hideActionButtons && (
                                <td className={classes.td_checkbox}>
                                  <Checkbox
                                    onChange={() => onCheckBoxChange(d.attachmentId)}
                                    checked={scriptAttachedIds.includes(d.attachmentId)}
                                  />
                                </td>
                              )}

                              <td onClick={() => onFileClick(d.attachmentId, d.scriptAttachment.title)}>
                                {d.scriptAttachment.title}
                              </td>

                              <td onClick={() => onFileClick(d.attachmentId, d.scriptAttachment.title)}>
                                {moment(d.createdAt)
                                  .format('MM-DD-YYYY')}
                              </td>

                              <td onClick={() => onFileClick(d.attachmentId, d.scriptAttachment.title)}>
                                {d.User.name}
                              </td>

                              <td onClick={() => onFileClick(d.attachmentId, d.scriptAttachment.title)}>
                                {d.scriptAttachment.type}
                              </td>
                            </tr>
                          ) : (
                            <tr key={`${d.id}`} onClick={() => onFileClick(d.title)}>

                              {header.map((h) => (
                                h.path === 'createdAt'
                                  ? (
                                    <td key={h.name}>
                                      {moment(d[h.path])
                                        .format('MM-DD-YYYY')}
                                    </td>
                                  )

                                  : <td key={h.name}>{d[h.path]}</td>
                              ))}
                            </tr>
                          )

                      ))}
                    </tbody>
                  </table>
                </div>

                {/* <Pagination */}
                {/* onChange={() => { */}
                {/* }} */}
                {/* limit={+15} */}
                {/* page={+10 - 1} */}
                {/* totalPage={+100} */}
                {/* /> */}
              </div>
            )}
        </>
      )}
    </div>
  );
};
AttachedFile.propTypes = {
  header: PropTypes.array.isRequired,
  attachments: PropTypes.array.isRequired,
  typeOptions: PropTypes.array.isRequired,
  firstLoad: PropTypes.bool.isRequired,
  requestStatus: PropTypes.string.isRequired,
  isOpenModal: PropTypes.bool.isRequired,
  setIsOpenModal: PropTypes.func.isRequired,
  onFileClick: PropTypes.func.isRequired,
  onSaveFile: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onChangeFile: PropTypes.func.isRequired,
  sendFile: PropTypes.object.isRequired,
  setSendFile: PropTypes.func.isRequired,
  onCheckBoxChange: PropTypes.func,
  isCheckedAllAttachedIds: PropTypes.bool,
  btnLoad: PropTypes.bool.isRequired,
  scriptAttachedIds: PropTypes.array,
  type: PropTypes.string,
  historyTabRef: PropTypes.object,
  hideActionButtons: PropTypes.bool,
};

export default AttachedFile;
